import type { HttpStatusCode } from 'axios'

export class DownloadError extends Error {
  constructor(
    message: string = 'Error al descargar el archivo',
    public httpStatusError?: HttpStatusCode
  ) {
    super(message)
    this.name = 'DownloadError'
  }
}
